var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page-price-overview-widget" }, [
    _c(
      "div",
      { staticClass: "search-component" },
      [
        _vm._t("default"),
        _vm._v(" "),
        _c("price-overview-widget", { attrs: { "set-form": _vm.setForm } })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-056b002d", { render: render, staticRenderFns: staticRenderFns })
  }
}